import { render, staticRenderFns } from "./SuggestMessage.vue?vue&type=template&id=b775ab40&scoped=true"
import script from "./SuggestMessage.vue?vue&type=script&lang=js"
export * from "./SuggestMessage.vue?vue&type=script&lang=js"
import style0 from "./SuggestMessage.vue?vue&type=style&index=0&id=b775ab40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b775ab40",
  null
  
)

export default component.exports